var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1928 24.7471C18.9414 24.7212 18.6398 24.7212 18.3633 24.7471C15.4782 24.6459 12.7445 23.389 10.7411 21.2424C8.7377 19.0958 7.62196 16.2282 7.63016 13.2468C7.63016 6.88666 12.6071 1.72062 18.7906 1.72062C20.2546 1.69335 21.7094 1.96414 23.072 2.51754C24.4347 3.07094 25.6784 3.8961 26.7323 4.94592C27.7861 5.99574 28.6294 7.24965 29.2141 8.63607C29.7987 10.0225 30.1132 11.5142 30.1396 13.0262C30.166 14.5381 29.9038 16.0406 29.368 17.4479C28.8321 18.8552 28.0331 20.1397 27.0166 21.2281C26.0001 22.3165 24.786 23.1875 23.4436 23.7912C22.1012 24.395 20.6567 24.7198 19.1928 24.7471ZM6.62471 34.3263C0.541763 38.5319 0.541763 45.3853 6.62471 49.5648C13.5372 54.3415 24.8736 54.3415 31.786 49.5648C37.869 45.3593 37.869 38.5059 31.786 34.3263C24.8987 29.5757 13.5623 29.5757 6.62471 34.3263Z",
    fill: "#E1EBEF",
    stroke: "#E1EBEF",
    strokeWidth: 3.44149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatar-icon.f2effeb639e17bd3af350b2e0fe9d3fc.svg";
export { ForwardRef as ReactComponent };